import { render, staticRenderFns } from "./DeXParaFilter.vue?vue&type=template&id=1349d3be&scoped=true&"
import script from "./DeXParaFilter.vue?vue&type=script&lang=js&"
export * from "./DeXParaFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349d3be",
  null
  
)

export default component.exports